import React from "react";

const HelpPdfPage = () => {
  const pdfUrl = `${process.env.PUBLIC_URL}/asset/061826_v1.1.4_ velakoda_guide.pdf`;

  return (
    <iframe
      title="Help PDF"
      src={pdfUrl}
      style={{ width: "100%", height: "100vh", border: 0 }}
    />
  );
};

export default HelpPdfPage;

